import { SpaEntityType } from 'shared-types/Spa';

export const resolveSpaMaxGuests = (
  entity: Pick<SpaEntityType, 'maximumGuests'>,
  { slotCapacity, requestedGuests = 1 }: { slotCapacity?: number; requestedGuests?: number } = {}
): number => {
  if (typeof entity.maximumGuests === 'number') {
    return slotCapacity != null
      ? Math.min(entity.maximumGuests, slotCapacity)
      : entity.maximumGuests;
  }
  return slotCapacity ?? Math.max(requestedGuests, 1);
};
